import { View, Text, StyleSheet, TouchableOpacity, TextInput, ActivityIndicator, FlatList, Dimensions, PixelRatio, Modal, Share } from 'react-native'
import React, { useEffect, useMemo, useState } from 'react'
import Colours from '../utils/Colours';
import { useNavigation } from '@react-navigation/native';
import SearchIcon from '../icons/SearchIcon';
import axios from '../api/axios';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth';
import Toast from 'react-native-toast-message';
import toastConfig from '../toasts/toastConfig';
import { useQuery } from '@tanstack/react-query';
import ErrorAlertComp from '../alertComp/ErrorAlertComp';
import * as Sharing from 'expo-sharing';
import * as FileSystem from 'expo-file-system'
import { Asset } from 'expo-asset';
import AppTextInput from '../utils/ColourThemes/AppTextInput';
import { Image } from 'expo-image';



const { width, height } = Dimensions.get('window');
const dpr = Math.round(PixelRatio.get() || 1);

// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = 'dxfdmlk0f';
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicFoundUserWidth = Math.round((width / BASE_WIDTH) * 45);
const dynamicFoundUserHeight = Math.round((width / BASE_WIDTH) * 45);


const UserListAndSearrchComp = ({
    title,
    number,
    tableID,
    getTableJoiners,
    tableJoinnersList,
    tableCaptionAddFriend
}) => {
    const [isFormContainerClicked, setIsFormContainerClicked] = useState(false)

    const [searchQuery, setSearchQuery] = useState('');


    const [isLoading, setIsLoading] = useState(false)
    const [isFriends, setIsFriends] = useState(false)
    const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);
    // const [addButtonVisible, setAddButtonVisible] = useState(true)
    // const [sentButtonVisible, setSentButtonVisible] = useState(false)
    const [userInTableRequests, setUserInTableRequests] = useState(false)
    //  const [userInTableRequest2, setUserInTableRequest2] = useState([])
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [requestSent, setRequestSent] = useState({})
    // const [requestSent, setRequestSent] = useState(false)

    // const [tableJoinersList2, setTableJoinersList2] = useState([])

    const [isLoadingButton, setIsLoadingButton] = useState({})
    const [isLoadingAddSearch, setIsLoadingAddSearch] = useState(false)



    // const [friendsList, setFriendsList] = useState([])
    //  const [updatedFriendsList, setUpdatedFriendsList] = useState([])
    const [isLoading12, setIsLoading12] = useState(false)


    const [retryCount, setRetryCount] = useState(0);
    const [imageKey, setImageKey] = useState(0);

    const [foundUser, setFoundUser] = useState()

    const [imageUrl, setImageUrl] = useState('')

    const { firstname, lastname, username } = useAuth()


    const navigation = useNavigation()

    const axiosPrivate = useAxiosPrivate()



    useEffect(() => {
        const loadAsset = async () => {
            const asset = Asset.fromModule(require('../../assets/meeza.png'));
            await asset.downloadAsync(); // Ensures the asset is loaded
            //console.log('Image loaded:', asset.localUri);
            setImageUrl(asset.localUri || null)
        };
        loadAsset()
    }, [])


    const getOptimizedCloudinaryUrl = (
        originalUrl,
        targetWidth,
        targetHeight
    ) => {
        if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
            return originalUrl;
        }

        // 1. Define the transformations
        const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

        //const transformations = `w_${targetWidth},f_auto,q_90,dpr_auto`;

        const regex = /upload\/v\d+\//;

        return originalUrl.replace(
            regex,
            `upload/${transformations}/`
        );
    };


    const handleImageError = () => {
        if (retryCount < MAX_RETRIEZ) {
            // Increment the retry counter
            setRetryCount(prevCount => prevCount + 1);

            // Force component re-render by changing the key
            setImageKey(prevKey => prevKey + 1);

            //console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
        } else {
            // Log final failure or set a state to show a permanent fallback icon
            //console.log('Image failed to load after maximum retries.');
        }
    };


    // Fetch table joiners
    const { data: tableJoinersData, isLoading: isLoadingJoiners, error: joinersError } = useQuery({
        queryKey: ['tableJoiners', tableID],
        queryFn: async () => {
            const response = await axiosPrivate.get(`/joiners/tableJoiners/${tableID}`);
            return {
                joined: response.data.joined,
                tableJoinRequests: response.data.tableJoined.tableJoinRequests,
            };
        },
        enabled: !!tableID, // Only run when tableID exists
    });

    // Extract data separately
    const tableJoinersList2 = tableJoinersData?.joined || [];
    const userInTableRequest2 = tableJoinersData?.tableJoinRequests || [];

    useEffect(() => {
        //console.log('tableJoinersList2', tableJoinersList2)
        //console.log('tableJoinersList2', tableJoinersList2.length)

        //console.log('userInTableRequest2', userInTableRequest2)
    }, [tableJoinersList2, userInTableRequest2])


    // Fetch friends list
    const { data: friendsList, isLoading: isLoadingFriends, error: friendsError } = useQuery({
        queryKey: ['userFriends'],
        queryFn: async () => {
            const response = await axiosPrivate.get('/friends');
            return response.data.friends;
        },
    });

    //Join FriendsList with tableJoinersList2 filter out or remove any duplicates


    const updatedFriendsList = useMemo(() => {
        if (!friendsList || !tableJoinersList2) return [];

        return friendsList.filter(friend =>
            !tableJoinersList2.some(joiner => joiner.userID?._id === friend._id)
        );
    }, [friendsList, tableJoinersList2]);

    useEffect(() => {
        //console.log("Updated FriendsList:", updatedFriendsList);
    }, [updatedFriendsList]);

    // useEffect(() => {
    //     if (!friendsList || !tableJoinersList2) return;
    //     const filterFriendsAndJoinedLists = () => {
    //         const filteredFriendsList = friendsList.filter(friend => !tableJoinersList2.some(joiner => joiner.userID._id === friend._id)
    //         );
    //         setUpdatedFriendsList(filteredFriendsList)

    //         //console.log("Updated FriendsList:", filteredFriendsList);
    //     }
    //     filterFriendsAndJoinedLists()
    // }, [tableJoinersList2, friendsList])

    // useEffect(() => {
    //     getUserFriends()
    //     //console.log('requestSent', requestSent)
    //     //console.log('tableJoinersList2', tableJoinersList2)

    // }, [tableJoinersList2])

    // const getUserFriends = async () => {
    //     setIsLoading12(true)
    //     await axiosPrivate.get('/friends').then((response) => {
    //         //console.log('FriendsList:', response.data.friends)
    //         setFriendsList(response.data.friends)
    //         setIsLoading12(false)
    //     }).catch((error) => {
    //         setIsLoading12(false)
    //         //console.log('ERROR FRIENDS:', error)
    //     })

    // }

    // const getTableJoiners2 = async () => {
    //     const joinedTableID = tableID
    //     //console.log('joinedTableID', joinedTableID)
    //     await axiosPrivate.get(`/joiners/tableJoiners/${joinedTableID}`).then((response) => {
    //         // //console.log('FriendsList:', response.data.friends)
    //         //console.log('response.data.tableJoined', response.data.tableJoined)
    //         if (response.status === 200 || response.status === 201) {
    //             setTableJoinersList2(response.data.joined)
    //             setUserInTableRequest2(response.data.tableJoined.tableJoinRequests)
    //             //  setTableJoinersNumber3(response.data.contributionsCount)

    //         } else {

    //         }
    //     }).catch((error) => {
    //         //console.log('ERROR FRIENDS:', error)
    //     })

    // }

    const handleAddFriendToTable = async (username) => {
        setIsLoadingButton((prev) => ({ ...prev, [username]: true }));
        setIsLoadingAddSearch(true)

        //setIsLoadingAdd(true)
        try {

            //console.log('username2', username)
            //setIsLoading(true)
            //console.log('tableID2', tableID)
            const response = await axiosPrivate.post(`/add/table/${tableID}/addFriend/${username}`)
            if (response.status === 200 || response.status === 201) {
                //console.log(response.data.message)
                //  setRequestSent(true)

                setRequestSent((prevState) => ({
                    ...prevState,
                    [username]: true,
                }))

            } else {
                // Toast.show({
                //     type: 'error',
                //     text1: 'Error',
                //     text2: error.response.data.message ? error.response.data.message : 'Unable to add friend to table',
                // })
                setErrorMessage(error.response.data.message ? error.response.data.message : 'Unable to add friend to table')
                setIsErrorCompVisible(true)
            }
        } catch (error) {

            if (error.response) {
                // Toast.show({
                //     type: 'error',
                //     text1: "Warning",
                //     text2: error.response.data.message ? error.response.data.message : 'Unable to add friend to table',

                // })
                setErrorMessage(error.response.data.message ? error.response.data.message : 'Unable to add friend to table')
                setIsErrorCompVisible(true)

            } else if (error.request) {
                // Toast.show({
                //     type: 'error',
                //     text1: 'Warning',
                //     text2: 'No response Recieved',
                // })
                setErrorMessage('No response Recieved')
                setIsErrorCompVisible(true)
            } else {
                // Toast.show({
                //     type: 'error',
                //     text1: 'Error!!!',
                //     text2: error.message,
                // })
                setErrorMessage(error.message)
                setIsErrorCompVisible(true)
            }

        } finally {
            setIsLoadingButton((prev) => ({ ...prev, [username]: false }));
            setIsLoadingAddSearch(false)

        }

    }

    // const searchUsernameAndFriends = async (username) => {
    //     try {
    //         //console.log("USERNAMEe", username)
    //         //console.log("TableIA", tableID)

    //         setIsLoading(true)
    //         const response = await axiosPrivate.get(`/search/find/${username}/findTable/${tableID}`);
    //         //console.log('response.data.exists:', response.data.exists)
    //         if (response.data.exists) {
    //             setIsLoading(false)
    //             setErrorMessage('');
    //             // //console.log("ResponseData:", response.data)
    //             //console.log('userInReq', response.data.userInRequests)
    //             setFoundUser(response.data)
    //             setIsFriends(response.data.isFriend)
    //             setIsUsernameAvailable(true);
    //             setUserInTableRequests(response.data.userInRequests)
    //             // setButtonActive(true)
    //         } else {
    //             setIsLoading(false)
    //             setIsUsernameAvailable(false);
    //             setIsFriends(false)
    //             setErrorMessage('Sorry!! this user was not found.');
    //             //  setButtonActive(false)
    //         }
    //     } catch (error) {
    //         setIsLoading(false)
    //         //console.log('Error checking username:', error);
    //         setErrorMessage('Error checking username. Please try again.');
    //         // setButtonActive(true)

    //     }
    // };

    // Fetch user search results
    const { isLoading: isLoadingSearch } = useQuery({
        queryKey: ['searchUser', searchQuery, tableID],
        queryFn: async () => {
            if (!searchQuery) return null; // Prevent unnecessary requests
            const response = await axiosPrivate.get(`/search/find/${searchQuery}/findTable/${tableID}`);
            if (response.data.exists) {
                setFoundUser(response.data);
                setIsUsernameAvailable(true);
                setIsFriends(response.data.isFriend);
                setUserInTableRequests(response.data.userInRequests);
                // setErrorMessage('');
            } else {
                setIsUsernameAvailable(false);
                setIsFriends(false);
                // setErrorMessage('Sorry! This user was not found.');
            }
            return response.data;
        },
        enabled: !!searchQuery, // Run query only when searchQuery exists
    });



    // const shareTable = async () => {
    //     const imageUrl = require('../../assets/meeza.png')

    //     try {

    //         if (imageUrl) {
    //             await Sharing.shareAsync(imageUrl);
    //             //  await Sharing.shareAsync(`${firstname} invites you to join the table ${tableCaptionAddFriend} to join,
    //             //     Download Meeza - "The Doings App"`);
    //         } else {
    //             //console.log('image not set')
    //         }

    //     } catch (error) {
    //         //console.error('Sharing failed:', error);
    //     }



    //     // try {
    //     //     await Share.open({
    //     //         url: imageUrl,
    //     //         message: `${firstname} invites you to join the table ${tableCaptionAddFriend} to join,
    //     //         Download Meeza - "The Doings App"`,
    //     //     });
    //     // } catch (error) {
    //     //     //console.log('Error sharing:', error);
    //     // }
    // };

    // const shareTable = async () => {
    //     try {
    //         const message = `${firstname} invites you to join the table ${tableCaptionAddFriend}.
    //         Download Meeza - "The Doings App" to join.`;

    //         await Sharing.shareAsync('', { dialogTitle: 'Share Table', mimeType: 'text/plain', UTI: 'public.plain-text', text: message });

    //     } catch (error) {
    //         //console.error('Sharing failed:', error);
    //     }
    // };

    const shareTable = async () => {
        try {
            const message = `${firstname} invites you to join the table ${tableCaptionAddFriend}.Download Meeza - "The Doings App" to join: https://getmeeza.com`;

            await Share.share({ message });

        } catch (error) {
            //console.error('Error sharing:', error);
        }
    };

    const foundUserImgUrl = foundUser?.data?.profilePicture

    const newfoundUserImgUrl = getOptimizedCloudinaryUrl(
        foundUserImgUrl,
        dynamicFoundUserWidth,
        dynamicFoundUserHeight,

    );


    return (
        <View>
            <View style={styles.higherTablebodyContainer}>
                <View style={styles.JoinedNumber}>
                    <Text style={styles.titleTxt} >{title} </Text>
                    <Text style={styles.sectionalTxt}>| {number}</Text>
                </View>
                <View style={styles.searchBoxContainer}>
                    <View style={styles.SearchBox}>
                        <AppTextInput
                            style={[styles.inputTxt, isFormContainerClicked && styles.focusedBorder,
                                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                            ]}
                            placeholder="Search User"
                            onFocus={() => setIsFormContainerClicked(true)}
                            onBlur={() => setIsFormContainerClicked(false)}
                            // value={tableCaption}setSearchQuery
                            //onChangeText={handleOnSearchContent}
                            onChangeText={setSearchQuery}
                        />
                    </View>
                    <View style={styles.dimacation}></View>
                    <SearchIcon color={Colours.DARKGRAY} />
                </View>

                {/* {isLoading ? ( */}
                {isLoadingSearch ? (

                    <View style={{ display: 'flex', height: 20, justifyContent: 'center', alignItems: 'center' }}>
                        <ActivityIndicator size={'small'} color={Colours.PRIMARY} />
                    </View>
                ) :
                    // {!isUsernameAvailable && <Text style={{ color: 'red' }}>{errorMessage}</Text>}

                    foundUser && isUsernameAvailable ? (<TouchableOpacity style={styles.profileContainer}>
                        <View style={styles.profileAndButtonContainer}>
                            <View style={styles.profileAndTextContainer}>

                                {newfoundUserImgUrl ? (
                                    <Image
                                        source={{ uri: newfoundUserImgUrl }}
                                        key={imageKey}
                                        style={[styles.userImage, { backgroundColor: '#d6d4d4ff' }]}
                                        contentFit="cover"
                                        cachePolicy="disk"
                                        onError={handleImageError}
                                    />
                                ) : (
                                    // 👇 fallback placeholder (optional)
                                    <View style={[styles.userImage, { backgroundColor: '#d6d4d4ff', justifyContent: 'center', alignItems: 'center' }]}>
                                        <Text style={{ color: '#999' }}> </Text>
                                    </View>
                                )}
                                <Text style={styles.usernameTxt}>{foundUser.data.username}</Text>

                                {/* <Text style={{color:Colours.DARKGRAY, fontFamily:'Sen-Regular' }}>Welcome</Text> */}
                            </View>

                            {foundUser.data.username === username ||
                                tableJoinersList2.some(joiner => joiner.userID.username === foundUser.data.username) ? (
                                <Text style={{ color: 'white', fontSize: 13, fontFamily: 'Sen-Bold' }}></Text>
                            ) :
                                !userInTableRequests && !requestSent[foundUser.data.username] ? (<TouchableOpacity style={styles.addFriendsButton}
                                    onPress={() => { handleAddFriendToTable(foundUser.data.username) }}>

                                    {isLoadingAddSearch ? (
                                        <ActivityIndicator size="small" color="white" />
                                    ) : (
                                        // <Text style={styles.addTxt}>Add +</Text>
                                        <Text style={styles.addTxt}>Tag +</Text>
                                    )}

                                </TouchableOpacity>
                                ) : (
                                    <Text style={styles.sentTxt}>Sent</Text>
                                )}
                        </View>
                    </TouchableOpacity>
                    ) : (
                        <Text style={{ color: 'red' }}></Text>
                    )}



            </View>

            <View style={styles.existFriendsContainer}>
                <View style={styles.JoinedNumber}>
                    <Text style={styles.joinedTxt} >SHARE TABLE</Text>
                    <Text style={styles.numberTxt}>| ++</Text>
                </View>
                <View style={styles.shareSocial}>
                    <TouchableOpacity style={styles.shareButton}
                        onPress={shareTable}
                    >
                        <Text style={styles.shareTxt}>Share</Text>
                    </TouchableOpacity>
                    <View style={styles.profileAndTextContainer}>
                        <Image source={require('../../assets/whatsApp.png')} style={styles.userImage} contentFit='cover' cachePolicy='disk' />
                        <Image source={require('../../assets/facebook.png')} style={styles.userImage} contentFit='cover' cachePolicy='disk' />
                        <Image source={require('../../assets/instagram.jpg')} style={styles.userImage} contentFit='cover' cachePolicy='disk' />
                    </View>
                    {/* </View> */}
                </View>
            </View>

            <View style={styles.existFriendsContainer}>
                <View style={styles.JoinedNumber}>
                    <Text style={styles.joinedTxt} >JOINED </Text>
                    <Text style={styles.numberTxt}>| {number}</Text>
                </View>

                {/* {isLoading12 ? ( */}
                {isLoadingFriends ? (

                    <View style={{ display: 'flex', height: 20, justifyContent: 'center', alignItems: 'center' }}>
                        <ActivityIndicator size={'small'} color={Colours.PRIMARY} />
                    </View>
                ) : (

                    <FlatList
                        data={tableJoinersList2.filter((item) => item.userID.username !== username)}
                        scrollEnabled={false}
                        keyExtractor={(item) => item._id}
                        renderItem={({ item: joined }) => {

                            const joinedUserImgUrl = joined?.userID?.profilePicture

                            const newJoinedUserImgUrl = getOptimizedCloudinaryUrl(
                                joinedUserImgUrl,
                                dynamicFoundUserWidth,
                                dynamicFoundUserHeight,

                            );

                            return (
                                <TouchableOpacity style={styles.profileContainer}>
                                    <View style={styles.profileAndButtonContainer}>
                                        <View style={styles.profileAndTextContainer}>
                                            <Image
                                                source={{ uri: newJoinedUserImgUrl }}
                                                key={imageKey}
                                                style={[styles.userImage, { backgroundColor: '#d6d4d4ff' }]}
                                                contentFit="cover"
                                                cachePolicy="disk"
                                                onError={handleImageError}
                                            />
                                            <Text style={styles.joinedUserTxt}>{joined?.userID?.username}</Text>
                                        </View>
                                    </View>
                                </TouchableOpacity>

                            )
                        }}

                    />
                )}
            </View>


            <View style={styles.existFriendsContainer}>
                <View style={styles.JoinedNumber}>
                    <Text style={styles.friendsTxt} >FRIENDS </Text>
                    <Text style={styles.dimacationNumberTxt}>| {number}</Text>
                </View>

                {/* {isLoading12 ? ( */}
                {isLoadingFriends ? (

                    <View style={{ display: 'flex', height: 20, justifyContent: 'center', alignItems: 'center' }}>
                        <ActivityIndicator size={'small'} color={Colours.PRIMARY} />
                    </View>
                ) : (

                    <FlatList
                        // data={friendsList}
                        data={updatedFriendsList.filter((item) => item.username !== username)}
                        scrollEnabled={false}
                        keyExtractor={(item) => item._id}
                        renderItem={({ item: friendData }) => {

                            const isLoadingAdd = isLoadingButton[friendData.username]

                            const isUserInTableRequests = userInTableRequest2.some(
                                (user) => user._id === friendData._id
                            );

                            const friendsUserImgUrl = friendData.profilePicture

                            const newFriendsUserImgUrl = getOptimizedCloudinaryUrl(
                                friendsUserImgUrl,
                                dynamicFoundUserWidth,
                                dynamicFoundUserHeight,

                            );

                            return (
                                <TouchableOpacity style={styles.profileContainer}>
                                    <View style={styles.profileAndButtonContainer}>
                                        <View style={styles.profileAndTextContainer}>
                                            <Image
                                                source={{ uri: newFriendsUserImgUrl }}
                                                key={imageKey}
                                                style={[styles.userImage, { backgroundColor: '#d6d4d4ff' }]}
                                                contentFit="cover"
                                                cachePolicy="disk"
                                                onError={handleImageError}
                                            />
                                            <Text style={styles.usernameFriendsTxt}>{friendData.username}</Text>
                                        </View>
                                        {!isUserInTableRequests && !requestSent[friendData.username] ? (<TouchableOpacity style={styles.addFriendsButton}
                                            // {!userInTableRequests && !requestSent ? (<TouchableOpacity style={styles.addFriendsButton}
                                            onPress={() => handleAddFriendToTable(friendData.username)}>
                                            {isLoadingAdd ? (
                                                <ActivityIndicator size="small" color='white' />
                                            ) : (
                                                <Text style={styles.addTxt}>Tag +</Text>
                                                // <Text style={styles.addTxt}>Add +</Text>
                                            )}
                                        </TouchableOpacity>
                                        ) : (
                                            <Text style={styles.sentTxt}>Sent</Text>
                                        )}
                                    </View>
                                </TouchableOpacity>

                            )
                        }}

                    />
                )}
            </View>

            <Modal
                visible={isErrorCompVisible}
                transparent={true}
                animationType="fade"
            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => setIsErrorCompVisible(false)}
                />
            </Modal>

            <Toast config={toastConfig} />
        </View>
    )
}

// const styles = StyleSheet.create({
//     higherTablebodyContainer: {
//         margin: 15,
//         marginTop: 0,
//         padding: 15,
//         // width: 400,
//         borderRadius: 15,
//         //   height:200,
//         backgroundColor: 'white',
//         //   backgroundColor: '#E8E8E8',
//         shadowColor: '#E8E8E8'
//     },
//     titleTxt: {
//         marginTop: 10,
//         marginBottom: 10,
//         fontSize: 15,
//         color: Colours.DARKLIGHTGRAY,
//         fontFamily: 'Sen-Bold'
//     },
//     sectionalTxt: {
//         paddingLeft: 1,
//         paddingBottom: 0,
//         color: Colours.PRIMARY,
//         fontFamily: 'Sen-Regular'
//     },
//     usernameTxt: {
//         fontSize: 16,
//         color: Colours.DARKGRAY,
//         fontFamily: 'Sen-Regular'
//     },
//     addTxt: {
//         color: 'white',
//         fontSize: 13,
//         fontFamily: 'Sen-Bold'

//     },
//     sentTxt: {
//         color: '#5bb450',
//         fontSize: 13,
//         fontFamily: 'Sen-Bold'

//     },
//     joinedTxt: {
//         marginTop: 10,
//         marginBottom: 10,
//         fontSize: 15,
//         color: Colours.DARKLIGHTGRAY,
//         fontFamily: 'Sen-Bold'
//     },
//     numberTxt: {
//         paddingLeft: 1,
//         paddingBottom: 0,
//         color: Colours.PRIMARY,
//         fontFamily: 'Sen-Regular'
//     },
//     joinedUserTxt: {
//         fontSize: 16,
//         color: Colours.DARKGRAY,
//         fontFamily: 'Sen-Regular'
//     },
//     friendsTxt: {
//         marginTop: 10,
//         marginBottom: 10,
//         fontSize: 15,
//         color: Colours.DARKLIGHTGRAY,
//         fontFamily: 'Sen-Bold'
//     },
//     dimacationNumberTxt: {
//         paddingLeft: 1,
//         paddingBottom: 0,
//         color: Colours.PRIMARY,
//         fontFamily: 'Sen-Regular'
//     },
//     usernameFriendsTxt: {
//         fontSize: 16,
//         color: Colours.DARKGRAY,
//         fontFamily: 'Sen-Regular'
//     },
//     dimacation: {
//         backgroundColor: Colours.DARKLIGHTGRAY,
//         height: 30,
//         width: 1,
//     },
//     existFriendsContainer: {
//         margin: 15,
//         marginTop: 0,
//         padding: 15,
//         // width: 400,
//         borderRadius: 15,
//         //   height:200,
//         backgroundColor: 'white',
//         //   backgroundColor: '#E8E8E8',
//         shadowColor: '#E8E8E8'
//     },
//     JoinedNumber: {
//         display: 'flex',
//         flexDirection: 'row',
//         //    justifyContent: 'center',
//         alignItems: 'center',
//         gap: 1,
//     },
//     inputTxt: {
//         height: 40,
//         width: 250,
//         marginTop: 10,
//         // gap: 10,
//         padding: 10,
//         borderWidth: 2.5,
//         borderColor: Colours.LIGHTGRAY,
//         borderRadius: 7,
//         fontFamily: 'Sen-Regular',
//         fontSize: 15,
//         backgroundColor: Colours.LIGHTGRAY,
//         marginBottom: 10,
//         marginRight: 10,
//     },

//     addFriendsButton: {
//         display: 'grid',
//         alignItems: 'center',
//         justifyContent: 'center',
//         borderRadius: 5,
//         backgroundColor: Colours.PRIMARY,
//         height: 30,
//         width: 80,
//     },

//     searchBoxContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         alignItems: 'center',
//         // backgroundColor:'blue',

//     },
//     focusedBorder: {
//         borderColor: Colours.PRIMARY,
//     },
//     userImage: {
//         width: 45,
//         height: 45,
//         borderRadius: 99,

//     },
//     profileContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         alignItems: 'center',
//         paddingTop: 10,
//         gap: 10,
//     },
//     profileAndButtonContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         width: 300,
//         alignItems: 'center'
//     },
//     profileAndTextContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         alignItems: 'center',
//         gap: 10,
//     }
// })

const styles = StyleSheet.create({
    higherTablebodyContainer: {
        margin: dynamicSpacing(15),
        marginTop: 0,
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
        shadowColor: '#E8E8E8',
    },
    titleTxt: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Bold',
    },
    sectionalTxt: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: 0,
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
    },
    usernameTxt: {
        fontSize: dynamicFontSize(16),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Regular',
    },
    addTxt: {
        color: 'white',
        fontSize: dynamicFontSize(13),
        fontFamily: 'Sen-Bold',
    },
    sentTxt: {
        color: '#5bb450',
        fontSize: dynamicFontSize(13),
        fontFamily: 'Sen-Bold',
    },
    joinedTxt: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Bold',
    },
    numberTxt: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: 0,
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
    },
    joinedUserTxt: {
        fontSize: dynamicFontSize(16),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Regular',
    },
    friendsTxt: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Bold',
    },
    dimacationNumberTxt: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: 0,
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
    },
    usernameFriendsTxt: {
        fontSize: dynamicFontSize(16),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Regular',
    },
    dimacation: {
        backgroundColor: Colours.DARKLIGHTGRAY,
        height: dynamicSize(30),
        width: dynamicSize(1),
    },
    existFriendsContainer: {
        margin: dynamicSpacing(15),
        marginTop: 0,
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
        shadowColor: '#E8E8E8',
    },
    JoinedNumber: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: dynamicSpacing(1),
    },
    inputTxt: {
        height: dynamicSize(40),
        width: width * 0.75, // Makes it responsive based on screen width
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(2.5),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: dynamicSpacing(10),
        marginRight: dynamicSpacing(10),
    },
    addFriendsButton: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: dynamicSize(5),
        backgroundColor: Colours.PRIMARY,
        height: dynamicSize(30),
        width: dynamicSize(80),
    },
    shareButton: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: dynamicSize(5),
        backgroundColor: Colours.PRIMARY,
        height: dynamicSize(30),
        width: dynamicSize(80),
    },
    shareTxt: {
        color: 'white',
        fontSize: dynamicFontSize(13),
        fontFamily: 'Sen-Bold',
    },
    shareSocial: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    searchBoxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    userImage: {
        width: dynamicSize(45),
        height: dynamicSize(45),
        borderRadius: 99, // Keeps it circular
    },
    profileContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: dynamicSpacing(10),
        gap: dynamicSpacing(10),
    },
    profileAndButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: width * 0.8, // Adjust width dynamically
        alignItems: 'center',
    },
    profileAndTextContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: dynamicSpacing(10),
    },
});

export default UserListAndSearrchComp